import './wallboard-view.component.ajscss';

import { ToastDeprecatedService } from '@commons/core/notification/toast-deprecated.service';
import { ng1Destroy } from '@commons/util/utilities/rx';
import { WallboardRouter } from '@wallboard/wallboard-router';
import { IWallboardService } from '@wallboard/wallboard.service';
import {
  copy,
  forEach,
  fromJson,
  IComponentController,
  IComponentOptions,
  IFormController,
  ILogService,
  isArray,
  isDefined,
  isObject,
  ITimeoutService,
  toJson,
} from 'angular';
import { i18n } from 'i18next';
import moment from 'moment';
import { Observable } from 'rxjs';
import { Path } from 'src/app/app-routing.module';

import {
  ChannelUtil,
  COMETD_WALLBOARD_SUPERVISOR_CONTENT,
  COMETD_WALLBOARD_SUPERVISOR_MESSAGE,
  Configuration,
  DisplayDeprecatedComponent,
  MessagingService,
  ProfileFacade,
  randomUUID,
  ToastClass,
  ToastType,
} from '@contact/upgrade';

import { wallboardTemplate1, wallboardTemplate2, wallboardTemplate3, wallboardTemplate4 } from '../models/template';
import templateUrl from './wallboard-view.component.ajs.html';

const MODULE_NAME = 'contactWallboard';

class WallboardViewCtrl extends DisplayDeprecatedComponent implements IComponentController {
  public name = MODULE_NAME;

  private login: string | undefined = undefined;
  private close$: Observable<void>;
  private toggle$: Observable<void>;
  private headerHover = false;
  // region Attributes
  // Toggle functions for menu, footer, demo mode
  private wallboardUuid = '';
  private wholeWallboard: any = {};
  private originalWallboard: any = {};
  private currentWallboard: any[] = [];
  public wallboardMode = false;
  public demoMode = false;
  public saveInProgress = false;
  public regex = /^[a-zA-Z0-9]*$/;
  private currentTemplate: any = {};
  private templateList: any;
  public currentDate: any;
  public timer: any;
  public tryToApplyResetPassword: boolean;
  // Metrics
  public metrics: any = {};
  // Box management
  private currentBox: any = {};
  private currentBoxRow: number;
  private currentBoxCol: number;
  private currentBoxX: number;
  private currentBoxY: number;
  private currentIndicBoxEdited: any = {};
  public currentIndicBoxMode = 'SETTINGS';
  private originalEditedItem = {};
  public hasOneboxEdited: boolean = false;
  public hasOneboxMoved: boolean = false;
  private originalBackgroundColor: any;
  private originalBackgroundImage: any;
  private originalBackgroundContain: any;
  // Images
  private imagesToAdd: any[] = [];
  private imagesToRemove: any[] = [];
  private originalImagesToAdd: any[];
  private originalImagesToRemove: any[];
  private selectedImageIndex: any = null;
  private tempEditionImage = {
    image: null,
    name: null,
  };
  private imagesLoaded = true;
  // Auto scroll for indicator box (25ms per px)
  private scrollSpeed = 25;
  // Indicators
  public currentNumericValue = 0;
  public targetTypeList: any[] = [];
  public targetList: any[] = [];
  public indicatorList: any[] = [];
  public customIndicatorList: any[] = [];
  public familyList: any;
  private teamIndicatorList: any;
  private groupIndicatorList: any;
  private contactSkillIndicatorListWithPhone: any;
  private contactSkillIndicatorList: any;
  private contactSkillQueueIndicatorList: any;
  private contactMailSkillIndicatorList: any;
  private campaignIndicatorList: any;
  private flowIndicatorList: any;
  private goalsSkillIndicatorListWithPhone: any;
  private goalsSkillIndicatorList: any;
  private contactFlowIndicatorList: any;
  private contactMailFlowIndicatorList: any;
  private counterIndicatorList: any;
  private serviceIndicatorList: any;
  private goalsMailChannelIndicatorList: any;
  private csrTargetTypeList: any;
  private contactTargetTypeList: any;
  private goalsTargetTypeList: any;
  private countersTargetTypeList: any;
  private availableTeams: any[] = [];
  private availableGroups: any[] = [];
  private availableSkills: any[] = [];
  private availableMissions: any[] = [];
  private availableFlows: any[] = [];
  private availableCampaigns: any[] = [];
  private availableCounters: any[] = [];
  private availableServices: any[] = [];
  private availableChannels: any[] = [];
  // Modal states
  public applyTemplateState: boolean;
  public templateSelected: boolean;
  public changeTemplateState: boolean;
  public renameWallboardState: boolean;
  public changeMailState: boolean;
  public changeBackgroundState: boolean;
  public exitWallboardState: boolean;
  public duplicateWallboardState: boolean;
  public changePositioningState: boolean;
  public importWallboardState: boolean;
  // Positioning
  private originalWallboardPositioning: boolean;
  private originalWallboardSpacing: string;
  // Duplicate wallboard
  private originalWallboardName: string;
  private originalWallboardMail: string;
  private duplicateWallboardDto: any;
  public wbForm: IFormController;
  // Import
  public importTemplate: string = '';
  // WYSIWYG
  private tinyMCE = window['tinyMCE'];
  private tinymce = window['tinymce'];
  // Grid
  public gridsterOpts: any = {
    columns: 12, // number of columns in the grid
    pushing: true, // whether to push other items out of the way
    floating: true, // whether to automatically float items up so they stack
    swapping: true, // whether or not to have items switch places instead of push down if they are the same size
    mobileModeEnabled: false, // whether or not to toggle mobile mode when screen width is less than mobileBreakPoint
    maxRows: 100, // maximum amount of rows in the grid
    resizable: {
      // options to pass to resizable handler
      enabled: true,
      handles: ['s', 'e', 'se', 'w'],
    },
  };
  public gridsterOpts2: any = {
    columns: 10, // number of columns in the grid
    margins: [1, 1], // margins in between grid items
    mobileModeEnabled: false, // whether or not to toggle mobile mode when screen width is less than mobileBreakPoint
    pushing: false, // whether to push other items out of the way
    floating: false, // whether to automatically float items up so they stack
    swapping: false, // whether or not to have items switch places instead of push down if they are the same size
    resizable: {
      // options to pass to resizable handler
      enabled: false,
    },
    draggable: {
      // options to pass to draggable handler
      enabled: false,
    },
  };
  public gridsterOpts3: any = {
    columns: 10, // number of columns in the grid
    margins: [1, 1], // margins in between grid items
    pushing: true, // whether to push other items out of the way
    floating: true, // whether to automatically float items up so they stack
    swapping: true, // whether or not to have items switch places instead of push down if they are the same size
    mobileModeEnabled: false, // whether or not to toggle mobile mode when screen width is less than mobileBreakPoint
    maxRows: 100, // maximum amount of rows in the grid
    draggable: {
      // options to pass to draggable handler
      enabled: true,
    },
    resizable: {
      // options to pass to resizable handler
      enabled: true,
      handles: ['s', 'e', 'se', 'w'],
    },
  };

  toggleDemoMode(demoMode: boolean) {
    this.demoMode = demoMode;
    window.dispatchEvent(new Event('resize'));
  }

  hover(is: boolean) {
    this.headerHover = is;
  }

  // endregion

  // region Constructor / Destructor
  constructor(
    private readonly $log: ILogService,
    private readonly $i18next: i18n,
    private readonly $timeout: ITimeoutService,
    private readonly profileFacade: ProfileFacade,
    private readonly wallboardService: IWallboardService,
    private readonly toastDeprecatedService: ToastDeprecatedService,
    private readonly messaging: MessagingService,
    private readonly configuration: Configuration,
    private readonly router: WallboardRouter
  ) {
    super();
  }

  $onInit() {
    this.close$.pipe(ng1Destroy(this)).subscribe(() => this.goToWallboardList());
    this.toggle$.pipe(ng1Destroy(this)).subscribe(() => this.toggleDemoMode(!this.demoMode));

    this.templateList = [
      { name: 'FREE', label: 'empty', template: [], selected: false },
      { name: 'TEMP1', label: 'Simple_1', template: wallboardTemplate1, selected: false },
      { name: 'TEMP2', label: 'Simple_2', template: wallboardTemplate2, selected: false },
      { name: 'TEMP3', label: 'Colored_1', template: wallboardTemplate3, selected: false },
      { name: 'TEMP4', label: 'Contrasted_1', template: wallboardTemplate4, selected: false },
    ];
    this.profileFacade.language$.pipe(ng1Destroy(this)).subscribe(lang => {
      moment.locale(lang);
    });
    this.currentDate = moment();
    this.timer = window.setInterval(() => (this.currentDate = moment()), 1000);

    this.wallboardService.onUpdated(metrics => this.treatMetrics(metrics));

    this.currentIndicBoxEdited.family = '';
    this.currentIndicBoxEdited.targetType = '';
    this.currentIndicBoxEdited.target = '';
    this.currentIndicBoxEdited.indicator = '';
    this.currentNumericValue = 0;
    this.familyList = this.wallboardService.wallboardFamilyList();
    this.teamIndicatorList = this.wallboardService.getTeamIndicatorList();
    this.groupIndicatorList = this.wallboardService.groupIndicatorList();
    this.contactSkillIndicatorListWithPhone = this.wallboardService.contactSkillIndicatorListWithPhone();
    this.contactSkillIndicatorList = this.wallboardService.contactSkillIndicatorList();
    this.contactSkillQueueIndicatorList = this.wallboardService.contactSkillQueueIndicatorList();
    this.contactMailSkillIndicatorList = this.wallboardService.contactMailSkillIndicatorList();
    this.campaignIndicatorList = this.wallboardService.campaignIndicatorList();
    this.flowIndicatorList = this.wallboardService.flowIndicatorList();
    this.goalsSkillIndicatorListWithPhone = this.wallboardService.goalsSkillIndicatorListWithPhone();
    this.goalsSkillIndicatorList = this.wallboardService.goalsSkillIndicatorList();
    this.contactFlowIndicatorList = this.wallboardService.contactFlowIndicatorList();
    this.contactMailFlowIndicatorList = this.wallboardService.contactMailFlowIndicatorList();
    this.counterIndicatorList = this.wallboardService.counterIndicatorList();
    this.serviceIndicatorList = this.wallboardService.serviceIndicatorList();
    this.csrTargetTypeList = this.wallboardService.csrTargetTypeList();
    this.contactTargetTypeList = this.wallboardService.contactTargetTypeList();
    this.goalsTargetTypeList = this.wallboardService.goalsTargetTypeList();
    this.countersTargetTypeList = this.wallboardService.countersTargetTypeList();
    this.goalsMailChannelIndicatorList = this.wallboardService.goalsMailChannelIndicatorList();

    // Init wallboard mode
    if (this.login === undefined) {
      this.demoMode = true;
      this.wallboardMode = true;
      this.gridsterOpts.draggable = { enabled: false };
      this.gridsterOpts.resizable = { enabled: false };
    }

    // Subscribe to supervisor messages
    if (this.wallboardMode) {
      this.messaging
        .forRemote()
        .listen$(COMETD_WALLBOARD_SUPERVISOR_MESSAGE)
        .pipe(ng1Destroy(this))
        .subscribe(data => this.onNewMessage(data));
      this.messaging
        .forRemote()
        .listen$(COMETD_WALLBOARD_SUPERVISOR_CONTENT)
        .pipe(ng1Destroy(this))
        .subscribe(data => this.onNewContent(data));
    }

    // Get wallboard and only subscribe to metrics in wallboard mode
    if (this.wallboardMode) {
      this.wallboardService.getWallboard().subscribe(value => {
        if (value.status !== 204 && isObject(value.data)) {
          this.wallboardUuid = value.data.data.uuid;
          this.currentWallboard = fromJson(value.data.data.template) || [];
          this.wholeWallboard = copy(value.data.data);
          this.gridsterOpts.floating = this.wholeWallboard.positioning;
          this.gridsterOpts.columns = this.wholeWallboard.spacing || 12;
          this.addMetaBox();
          const customIndicatorsId = this.getWallboardCustomIndicatorsUuid();
          if (customIndicatorsId.length > 0) {
            const query = this.wallboardService.buildWallboardIndicatorRequest(customIndicatorsId);
            this.wallboardService.execSearchRequest(JSON.stringify(query)).subscribe(response => {
              if (response.data) {
                const customIndicators: any[] = [];
                for (let i = 0; i < response.data.hits.hits.length; i++) {
                  if (response.data.hits.hits[i]._source != null) {
                    customIndicators.push(response.data.hits.hits[i]._source);
                  }
                }
                this.addCustomIndicatorPropertiesToWallboard(customIndicators);
              }
              this.wallboardService.subscribeWallboardMetrics(this.wallboardUuid, this.currentWallboard);
            });
          } else {
            this.wallboardService.subscribeWallboardMetrics(this.wallboardUuid, this.currentWallboard);
          }
          // Start sequence mode for indicators box
          this.initSequenceMode();
          // Get wallboard images
          this.initWallboardImages(this.wallboardUuid);
          // Ready to receive planned content messages
          this.wallboardService.getCurrentContent(this.wallboardUuid);
          // Start auto scroll for indicators box and slideshows for images
          setTimeout(() => {
            this.initAutoScroll();
            this.initSlideshowMode();
          }, 6000);
        }
      });
    } else {
      this.wallboardService.getWallboard(this.login).subscribe(value => {
        if (value.status !== 204 && isObject(value.data)) {
          this.originalWallboard = copy(value.data.data);
          this.wholeWallboard = copy(value.data.data);
          this.gridsterOpts.floating = this.wholeWallboard.positioning;
          this.gridsterOpts.columns = this.wholeWallboard.spacing || 12;
          this.currentWallboard = fromJson(value.data.data.template) || [];
          this.addMetaBox();
          // Start sequence mode for indicators box
          this.initSequenceMode();
          // Get wallboard images
          this.initWallboardImages(value.data.data.uuid);
          // Start slideshows for images
          setTimeout(() => this.initSlideshowMode(), 6000);
        }
      });
    }

    // Get entity list for edit mode
    if (!this.wallboardMode) {
      this.wallboardService.getTeams().subscribe(response => {
        if (response.status !== 204 && isObject(response.data)) {
          response.data.data.sort((a, b) =>
            a.name.localeCompare(b.name, undefined, {
              sensitivity: 'base',
              numeric: true,
            })
          );
          this.availableTeams = response.data.data;
        }
      });
      this.wallboardService.getGroups().subscribe(response => {
        if (response.status !== 204 && isObject(response.data)) {
          response.data.data.sort((a, b) =>
            a.name.localeCompare(b.name, undefined, {
              sensitivity: 'base',
              numeric: true,
            })
          );
          this.availableGroups = response.data.data;
        }
      });
      this.wallboardService.getSkills().subscribe(response => {
        if (response.status !== 204 && isObject(response.data)) {
          response.data.data.sort((a, b) =>
            a.name.localeCompare(b.name, undefined, {
              sensitivity: 'base',
              numeric: true,
            })
          );
          this.availableSkills = response.data.data;
        }
      });
      this.wallboardService.getMissions().subscribe(response => {
        if (response.status !== 204 && isObject(response.data)) {
          response.data.data.sort((a, b) =>
            a.name.localeCompare(b.name, undefined, {
              sensitivity: 'base',
              numeric: true,
            })
          );
          this.availableMissions = response.data.data;
        }
      });
      this.wallboardService.getCounters().subscribe(response => {
        if (response.status !== 204 && isObject(response.data)) {
          response.data.data.sort((a, b) =>
            a.name.localeCompare(b.name, undefined, {
              sensitivity: 'base',
              numeric: true,
            })
          );
          this.availableCounters = response.data.data;
        }
      });
      this.wallboardService.getServices().subscribe(response => {
        if (response.status !== 204 && isObject(response.data)) {
          response.data.data.sort((a, b) =>
            a.name.localeCompare(b.name, undefined, {
              sensitivity: 'base',
              numeric: true,
            })
          );
          this.availableServices = response.data.data;
        }
      });
      this.wallboardService.getChannels().subscribe(response => {
        if (response.status !== 204 && isObject(response.data)) {
          response.data.data.sort((a, b) =>
            a.type.localeCompare(b.type, undefined, {
              sensitivity: 'base',
              numeric: true,
            })
          );
          response.data.data.forEach(channel => {
            if (channel.type === 'MAIL') {
              this.availableChannels.push({
                name: this.$i18next.t('commons:basic.channels.' + ChannelUtil.toString(channel)),
                uuid: ChannelUtil.toString(channel),
              });
            }
          });
        }
      });
      this.wallboardService.getMediaEntryPoints().subscribe(response => {
        if (response.status !== 204 && isObject(response.data)) {
          response.data.data.sort((a, b) =>
            a.name.localeCompare(b.name, undefined, {
              sensitivity: 'base',
              numeric: true,
            })
          );
          this.availableFlows = response.data.data;
          // Retrieve all campaigns and filter on the realStatus
          this.wallboardService.getCampaigns(this.availableFlows).then(success => {
            this.availableCampaigns = success.data.reduce((result, campaign) => {
              if (campaign.realStatus !== 'ENDED' && campaign.realStatus !== 'NOT_STARTED') {
                result.push({
                  uuid: campaign.idCampaign,
                  name: campaign.name,
                });
              }
              return result;
            }, []);
          });
        }
      });
      this.wallboardService.getCustomIndicators().then(response => {
        if (response.status !== 204 && isObject(response.data)) {
          response.data.data.sort((a, b) =>
            a.name.localeCompare(b.name, undefined, {
              sensitivity: 'base',
              numeric: true,
            })
          );
          this.customIndicatorList = response.data.data;
        }
      });

      // Exit without saving warning
      window.onbeforeunload = () => {
        if (this.wallboardMode) {
          this.wallboardService.reset();
        }
      };
    }
  }

  // endregion

  // region OnChange
  onChangeCurrentIndicBoxEditedMinThreshold() {
    if (this.currentIndicBoxEdited.minThreshold >= this.currentIndicBoxEdited.maxThreshold) {
      this.currentIndicBoxEdited.maxThreshold = this.currentIndicBoxEdited.minThreshold;
    }
  }

  onChangeCurrentBoxDisplay() {
    this.setSettingMode();
    if (this.currentBox.display === 'SEQUENCE' && (isNaN(this.currentBox.refreshMinutes) || isNaN(this.currentBox.refreshSeconds))) {
      this.currentBox.refreshMinutes = 0;
      this.currentBox.refreshSeconds = 5;
    }
  }

  onChangeCurrentIndicBoxEditedFamily(loadingIndicator) {
    if (this.currentIndicBoxEdited.family === 'CSR') {
      this.targetTypeList = this.csrTargetTypeList;
    } else if (this.currentIndicBoxEdited.family === 'CONTACT') {
      this.targetTypeList = this.contactTargetTypeList;
    } else if (this.currentIndicBoxEdited.family === 'GOALS') {
      this.targetTypeList = this.goalsTargetTypeList;
    } else if (this.currentIndicBoxEdited.family === 'COUNTERS') {
      this.targetTypeList = this.countersTargetTypeList;
    } else {
      this.targetTypeList = [];
    }
    if (!loadingIndicator) {
      this.currentIndicBoxEdited.targetType = '';
    }
    this.onChangeCurrentIndicBoxEditedTargetType(loadingIndicator);
  }

  onChangeCurrentIndicBoxEditedTargetType(loadingIndicator) {
    if (this.currentIndicBoxEdited.targetType === 'TEAM') {
      this.targetList = this.availableTeams;
      this.indicatorList = this.teamIndicatorList;
    } else if (this.currentIndicBoxEdited.targetType === 'GROUP') {
      this.targetList = this.availableGroups;
      this.indicatorList = this.groupIndicatorList;
    } else if (this.currentIndicBoxEdited.targetType === 'SKILL') {
      this.targetList = this.availableSkills;
      if (this.currentIndicBoxEdited.family === 'CONTACT') {
        this.indicatorList = this.contactSkillIndicatorList;
      } else if (this.currentIndicBoxEdited.family === 'GOALS') {
        this.indicatorList = this.goalsSkillIndicatorList;
      }
    } else if (this.currentIndicBoxEdited.targetType === 'SKILLS_QUEUE') {
      this.targetList = this.availableSkills.map(skill => ({ uuid: skill.uuid, name: skill.name }));
      if (this.currentIndicBoxEdited.family === 'CONTACT') {
        this.indicatorList = this.contactSkillQueueIndicatorList;
      }
    } else if (this.currentIndicBoxEdited.targetType === 'MISSION') {
      this.targetList = this.availableMissions;
    } else if (this.currentIndicBoxEdited.targetType === 'FLOW') {
      this.targetList = this.availableFlows;
      if (this.currentIndicBoxEdited.family === 'CONTACT') {
        const isEmailFlow = this.isEmailFlow();
        if (isEmailFlow) {
          this.indicatorList = this.contactMailFlowIndicatorList;
        } else {
          this.indicatorList = this.contactFlowIndicatorList;
        }
      } else {
        this.indicatorList = this.flowIndicatorList;
      }
    } else if (this.currentIndicBoxEdited.targetType === 'CAMPAIGN') {
      this.targetList = this.availableCampaigns;
      this.indicatorList = this.campaignIndicatorList;
    } else if (this.currentIndicBoxEdited.targetType === 'COUNTER') {
      this.targetList = this.availableCounters;
      this.indicatorList = this.counterIndicatorList;
    } else if (this.currentIndicBoxEdited.targetType === 'SERVICE') {
      this.targetList = this.availableServices;
      this.indicatorList = this.serviceIndicatorList;
    } else if (this.currentIndicBoxEdited.targetType === 'CHANNEL') {
      this.targetList = this.availableChannels;
      this.indicatorList = this.goalsMailChannelIndicatorList;
    } else {
      this.targetList = [];
      this.indicatorList = [];
    }
    if (!loadingIndicator) {
      if (this.currentIndicBoxEdited.targetType === 'SKILLS_QUEUE') {
        this.currentIndicBoxEdited.target = [];
      } else {
        this.currentIndicBoxEdited.target = '';
      }
      this.currentIndicBoxEdited.indicator = '';
    }
    this.onChangeCurrentIndicBoxEditedTarget();
  }

  onChangeCurrentIndicBoxEditedTarget() {
    if (this.currentIndicBoxEdited.targetType === 'SKILL') {
      const skillHasPhoneIncoming = this.skillHasPhoneIncoming();
      if (this.currentIndicBoxEdited.family === 'GOALS') {
        if (skillHasPhoneIncoming) {
          this.indicatorList = this.goalsSkillIndicatorListWithPhone;
        } else {
          this.indicatorList = this.goalsSkillIndicatorList;
        }
      } else if (this.currentIndicBoxEdited.family === 'CONTACT') {
        const isEmailSkill = this.isEmailSkill();
        const skillHasChat = this.skillHasChat();
        if (isEmailSkill) {
          this.indicatorList = this.contactMailSkillIndicatorList;
        } else if (skillHasPhoneIncoming) {
          if (skillHasChat) {
            this.indicatorList = this.contactSkillIndicatorListWithPhone.filter(
              indicator => indicator.id !== 'SUM_CSR_POST_PROCESSING_SKILL_NOW' && indicator.id !== 'SUM_CTT_GAVE_UP_IN_LESS_THAN_24S_SKILL'
            );
          } else {
            this.indicatorList = this.contactSkillIndicatorListWithPhone;
          }
        } else if (skillHasChat) {
          this.indicatorList = this.contactSkillIndicatorList.filter(
            indicator => indicator.id !== 'SUM_CSR_POST_PROCESSING_SKILL_NOW' && indicator.id !== 'SUM_CTT_GAVE_UP_IN_LESS_THAN_24S_SKILL'
          );
        } else {
          this.indicatorList = this.contactSkillIndicatorList;
        }
      }
    } else if (this.currentIndicBoxEdited.family === 'CONTACT' && this.currentIndicBoxEdited.targetType === 'SKILLS_QUEUE') {
      const skillQueueHasChat = this.skillQueueHasChat();
      if (skillQueueHasChat) {
        this.indicatorList = this.contactSkillQueueIndicatorList.filter(
          indicator =>
            indicator.id !== 'skills-tuple_nb_agent_post_processing_queue_all_channel_now' &&
            indicator.id !== 'skills-tuple_nb_contact_gave_up_in_less_than_a_duration'
        );
      } else {
        this.indicatorList = this.contactSkillQueueIndicatorList;
      }
    } else if (this.currentIndicBoxEdited.family === 'CONTACT' && this.currentIndicBoxEdited.targetType === 'FLOW') {
      const isEmailFlow = this.isEmailFlow();
      if (isEmailFlow) {
        this.indicatorList = this.contactMailFlowIndicatorList;
      } else {
        this.indicatorList = this.contactFlowIndicatorList;
      }
    }
  }

  onSelectCurrentIndicBoxEditedType(value) {
    this.setSettingMode();
    if (value !== 'STATIC') {
      this.currentIndicBoxEdited.value = '-';
    } else if (value === 'STATIC') {
      this.currentIndicBoxEdited.hasThresholds = false;
    }
    if (
      (value === 'CUSTOM' && this.currentIndicBoxEdited.type === 'NORMAL') ||
      (value === 'NORMAL' && this.currentIndicBoxEdited.type === 'CUSTOM')
    ) {
      this.currentIndicBoxEdited.indicator = '';
    }
    if (value === 'STATIC') {
      this.currentIndicBoxEdited.prefix = '';
      this.currentIndicBoxEdited.suffix = '';
    }
    if (value === 'EXTERNAL' && (isNaN(this.currentIndicBoxEdited.refreshMinutes) || isNaN(this.currentIndicBoxEdited.refreshSeconds))) {
      this.currentIndicBoxEdited.refreshMinutes = 0;
      this.currentIndicBoxEdited.refreshSeconds = 5;
    }
    if (value === 'EXTERNAL' && !isDefined(this.currentIndicBoxEdited.url)) {
      this.currentIndicBoxEdited.url = '';
    }
    this.currentIndicBoxEdited.type = value;
  }

  isEmailFlow() {
    return this.availableFlows.some(flow => flow.uuid === this.currentIndicBoxEdited.target && flow.media.mediaType === 'MAIL');
  }

  skillHasPhoneIncoming() {
    return this.availableSkills.some(
      skill =>
        skill.uuid === this.currentIndicBoxEdited.target &&
        skill.channelConfDtos.some(channelConf => channelConf.mediaType === 'PHONE' && channelConf.mediaDirection === 'INCOMING')
    );
  }

  skillHasChat() {
    return this.availableSkills.some(
      skill =>
        skill.uuid === this.currentIndicBoxEdited.target &&
        skill.channelConfDtos.some(channelConf => channelConf.mediaType === 'CHAT' && channelConf.mediaDirection === 'INCOMING')
    );
  }

  skillQueueHasChat() {
    return this.availableSkills.some(
      skill =>
        this.currentIndicBoxEdited.target.some(target => target.uuid === skill.uuid) &&
        skill.channelConfDtos.some(channelConf => channelConf.mediaType === 'CHAT' && channelConf.mediaDirection === 'INCOMING')
    );
  }

  isEmailSkill() {
    return this.availableSkills.some(
      skill =>
        skill.uuid === this.currentIndicBoxEdited.target &&
        skill.channelConfDtos.length === 1 &&
        skill.channelConfDtos[0].mediaType === 'MAIL' &&
        skill.channelConfDtos[0].mediaDirection === 'INCOMING'
    );
  }

  // endregion

  // region Wallboard templates
  templateModal() {
    this.changeTemplateState = true;
  }

  confirmApplyChangeTemplate() {
    this.changeTemplateState = false;
    this.applyTemplateState = true;
  }

  cancelApplyChangeTemplate() {
    this.changeTemplateState = false;
    this.templateSelected = false;
    this.templateList.forEach(template => (template.selected = false));
  }

  changeTemplate(index) {
    this.templateSelected = true;
    this.currentTemplate = this.templateList[index];
    this.templateList.forEach(template => (template.selected = false));
    this.templateList[index].selected = true;
  }

  applyTemplate() {
    this.applyTemplateState = true;
  }

  confirmApplyTemplate() {
    this.applyTemplateState = false;
    this.templateSelected = false;
    this.currentWallboard = this.currentTemplate.template;
    this.currentTemplate = {};
  }

  cancelApplyTemplate() {
    this.applyTemplateState = false;
    this.changeTemplateState = true;
  }

  // endregion

  // region Rename / Change mail
  renameWallboard() {
    this.renameWallboardState = true;
    this.originalWallboardName = this.wholeWallboard.name;
  }

  confirmApplyRenameWallboard() {
    this.renameWallboardState = false;
  }

  cancelApplyRenameWallboard() {
    this.renameWallboardState = false;
    this.wholeWallboard.name = this.originalWallboardName;
  }

  changeMail() {
    this.changeMailState = true;
    this.originalWallboardMail = this.wholeWallboard.mail;
  }

  confirmChangeMail() {
    this.changeMailState = false;
  }

  cancelChangeMail() {
    this.changeMailState = false;
    this.wholeWallboard.mail = this.originalWallboardMail;
  }

  // endregion

  // region Import / export
  openImportWallboard() {
    this.importWallboardState = true;
  }

  cancelImportWallboard() {
    this.importTemplate = '';
    this.importWallboardState = false;
  }

  confirmImportWallboard() {
    if (this.importTemplate !== '') {
      this.currentWallboard.forEach(box => {
        if (box.type === 'IMAGE' && box.images != null) {
          box.images.forEach(image => this.removeImageToList(image.name));
        }
      });
      this.currentWallboard = fromJson(this.importTemplate);
      this.cancelImportWallboard();
    }
  }

  exportWallboard() {
    this.wallboardService.exportWallboard(this.currentWallboard, this.wholeWallboard.name);
  }

  // endregion

  // region Change Main Background
  removeBgImg() {
    let metaBox: any = this.getMetaBox();
    this.removeImageToList(metaBox.backgroundImage.name);
    metaBox.backgroundImage = '';
  }

  changeBackground() {
    this.changeBackgroundState = true;
    this.currentWallboard.forEach(box => {
      if (box.type === 'META') {
        this.originalBackgroundColor = box.backgroundColor;
        this.originalBackgroundImage = box.backgroundImage;
        this.originalBackgroundContain = box.backgroundContain;
      }
    });
    this.originalImagesToAdd = copy(this.imagesToAdd);
    this.originalImagesToRemove = copy(this.imagesToRemove);
  }

  confirmApplyChangeBackground() {
    this.changeBackgroundState = false;
  }

  cancelApplyChangeBackground() {
    this.changeBackgroundState = false;
    this.currentWallboard.forEach(box => {
      if (box.type === 'META') {
        box.backgroundColor = this.originalBackgroundColor;
        box.backgroundImage = this.originalBackgroundImage;
        box.backgroundContain = this.originalBackgroundContain;
      }
    });
    this.imagesToAdd = this.originalImagesToAdd;
    this.imagesToRemove = this.originalImagesToRemove;
  }

  // endregion

  // region Duplicate
  openDuplicateWallboard() {
    this.duplicateWallboardState = true;
    this.duplicateWallboardDto = {
      name: '',
      login: '',
      mail: '',
    };
  }

  closeDuplicateWallboard() {
    this.duplicateWallboardState = false;
  }

  duplicateWallboard() {
    this.wallboardService.duplicateWallboard(this.wholeWallboard.uuid, this.duplicateWallboardDto).then(
      response => {
        if (response.status === 201) {
          this.toastDeprecatedService.add(ToastType.NOTIFICATION, 'wallboard:toast.duplicateSuccess', ToastClass.WALLBOARD, 2500);
          this.profileFacade.addVisibleWallboard(response.data.data);
        } else {
          this.toastDeprecatedService.alert('wallboard:toast.duplicateError');
        }
      },
      response => {
        if (response.data != null && response.data.errorCode === 'LOGIN_USED') {
          this.toastDeprecatedService.alert('wallboard:toast.duplicateErrorLogin');
        } else {
          this.toastDeprecatedService.alert('wallboard:toast.duplicateError');
        }
      }
    );
    this.closeDuplicateWallboard();
  }

  // endregion

  // region Password reset
  applyResetPassword() {
    this.tryToApplyResetPassword = true;
  }

  confirmApplyResetPassword() {
    this.tryToApplyResetPassword = false;
    this.wallboardService.resetPassword(this.wholeWallboard.uuid).then(
      value => {
        if (value.status === 200) {
          this.toastDeprecatedService.add(ToastType.NOTIFICATION, 'wallboard:toast.resetSuccess', ToastClass.WALLBOARD, 2500);
        } else {
          this.toastDeprecatedService.alert('wallboard:toast.resetError');
        }
      },
      () => this.toastDeprecatedService.alert('wallboard:toast.resetError')
    );
  }

  cancelApplyResetPassword() {
    this.tryToApplyResetPassword = false;
  }

  // endregion

  // region change positioning & spacing
  changePositioning() {
    this.wholeWallboard.spacing = this.wholeWallboard.spacing.toString();
    this.changePositioningState = true;
    this.originalWallboardPositioning = this.wholeWallboard.positioning;
    this.originalWallboardSpacing = this.wholeWallboard.spacing;
  }

  confirmChangePositioning() {
    this.changePositioningState = false;
    this.gridsterOpts.floating = this.wholeWallboard.positioning;
    this.gridsterOpts.columns = this.wholeWallboard.spacing;
  }

  cancelChangePositioning() {
    this.changePositioningState = false;
    this.wholeWallboard.positioning = this.originalWallboardPositioning;
    this.wholeWallboard.spacing = this.originalWallboardSpacing;
  }

  // endregion

  // region Metrics
  private getWallboardCustomIndicatorsUuid() {
    const indicators: any[] = [];
    this.currentWallboard.forEach(template => {
      if (template.type === 'INDICATOR' && template.array !== undefined) {
        template.array.forEach(indicator => {
          if (indicator.type === 'CUSTOM') {
            indicators.push(indicator.indicator);
          }
        });
      }
    });
    return indicators;
  }

  private addCustomIndicatorPropertiesToWallboard(customIndicators) {
    this.currentWallboard.forEach(template => {
      if (template.type === 'INDICATOR' && template.array !== undefined) {
        template.array.forEach(indicator => {
          if (indicator.type === 'CUSTOM') {
            let ci = customIndicators.filter(customIndicator => customIndicator.uuid === indicator.indicator);
            if (ci.length > 0) {
              indicator.properties = fromJson(ci[0].properties);
            }
          }
        });
      }
    });
  }

  private calculateIndicator(calc) {
    let ops = ['*', '/', '-', '+'];
    let opFunctions = [(a, b) => a * b, (a, b) => a / b, (a, b) => a - b, (a, b) => a + b];
    let newCalc: any[] = [];
    let currentOp: any = null;
    let begin = calc.indexOf('(');
    let end = 0;
    if (begin !== -1) {
      // While there are brackets
      while (begin !== -1) {
        let insideBracket = 0;
        // Look for the first bracket
        for (let k = begin + 1; k < calc.length; k++) {
          if (calc[k] === '(') {
            insideBracket++;
          } else if (calc[k] === ')') {
            if (insideBracket === 0) {
              end = k;
              break;
            } else {
              insideBracket--;
            }
          }
        }
        // Recursive call on first bracket
        if (end !== 0) {
          newCalc = calc.slice(0, begin);
          newCalc.push(this.calculateIndicator(calc.slice(begin + 1, end)));
          calc = newCalc.concat(calc.slice(end + 1));
        } else {
          this.$log.error('Error: unable to resolve calculation');
          return '-';
        }

        begin = calc.indexOf('(');
      }
    }

    // End the calculation (all brackets have been calculated)
    for (let i = 0; i < ops.length; i++) {
      newCalc = [];
      for (let j = 0; j < calc.length; j++) {
        if (calc[j] === ops[i]) {
          currentOp = opFunctions[i];
        } else if (currentOp) {
          newCalc[newCalc.length - 1] = currentOp(newCalc[newCalc.length - 1], calc[j]);
          currentOp = null;
        } else {
          newCalc.push(calc[j]);
        }
      }
      calc = newCalc;
    }
    if (calc.length > 1) {
      this.$log.error('Error: unable to resolve calculation');
      return '-';
    } else {
      return calc[0];
    }
  }

  private treatMetrics(metrics) {
    this.currentWallboard.forEach(template => {
      if (template.type === 'INDICATOR') {
        if (template.display === 'GRID' || template.display === 'SEQUENCE') {
          template.array.forEach(indicator => {
            if (indicator.type === 'NORMAL') {
              if (isArray(indicator.target)) {
                const metricKey = this.wallboardService.formatMetricKey(indicator);
                if (isDefined(metrics[metricKey])) {
                  indicator.value = metrics[metricKey];
                }
              } else if (isDefined(metrics[indicator.target + '@' + indicator.indicator])) {
                indicator.value = metrics[indicator.target + '@' + indicator.indicator];
              } else {
                indicator.value = '-';
              }
            } else if (indicator.type === 'EXTERNAL') {
              if (isDefined(metrics[indicator.id])) {
                indicator.value = metrics[indicator.id];
              } else {
                indicator.value = '-';
              }
            } else if (indicator.type === 'CUSTOM' && indicator.properties != null) {
              let canCalc = true;
              let calc: any[] = [];
              indicator.properties.forEach(property => {
                if (isObject(property)) {
                  if (isArray(property.target)) {
                    const metricKey = this.wallboardService.formatMetricKey(property);
                    if (isDefined(metrics[metricKey])) {
                      property.value = metrics[metricKey];
                      calc.push(property.value);
                    }
                  } else if (isDefined(metrics[property.target + '@' + property.indicator])) {
                    property.value = metrics[property.target + '@' + property.indicator];
                    calc.push(property.value);
                  } else if (property.target === undefined && !isNaN(property.indicator)) {
                    property.value = property.indicator;
                    calc.push(property.value);
                  } else {
                    canCalc = false;
                    property.value = '-';
                  }
                } else {
                  calc.push(property);
                }
              });
              if (canCalc) {
                indicator.value = this.calculateIndicator(calc);
                // fix for LBP
                if (calc.indexOf('*') !== -1 && calc.indexOf(100) !== -1) {
                  if (!isNaN(indicator.value) && isFinite(indicator.value)) {
                    indicator.value = Math.round(indicator.value * 100) / 100 + '%';
                  } else {
                    indicator.value = '0%';
                  }
                }
              }
            }
          });
        } else if (template.display === 'PIE' || template.display === 'BAR') {
          let chartData = {};
          template.array.forEach(indicator => {
            chartData[indicator.background] = 0;
            if (isArray(indicator.target)) {
              const metricKey = this.wallboardService.formatMetricKey(indicator);
              if (isDefined(metrics[metricKey])) {
                chartData[indicator.background] = metrics[metricKey];
              }
            } else if (indicator.type === 'NORMAL' && isDefined(metrics[indicator.target + '@' + indicator.indicator])) {
              chartData[indicator.background] = metrics[indicator.target + '@' + indicator.indicator];
            } else if (indicator.type === 'EXTERNAL' && isDefined(metrics[indicator.id])) {
              chartData[indicator.background] = metrics[indicator.id];
            } else if (indicator.type === 'CUSTOM' && indicator.properties != null) {
              let canCalc = true;
              let calc: any[] = [];
              indicator.properties.forEach(property => {
                if (isObject(property)) {
                  if (isArray(property.target)) {
                    const metricKey = this.wallboardService.formatMetricKey(property);
                    if (isDefined(metrics[metricKey])) {
                      property.value = metrics[metricKey];
                      calc.push(property.value);
                    }
                  } else if (isDefined(metrics[property.target + '@' + property.indicator])) {
                    property.value = metrics[property.target + '@' + property.indicator];
                    calc.push(property.value);
                  } else if (property.target === undefined && !isNaN(property.indicator)) {
                    property.value = property.indicator;
                    calc.push(property.value);
                  } else {
                    canCalc = false;
                  }
                } else {
                  calc.push(property);
                }
              });
              if (canCalc) {
                chartData[indicator.background] = this.calculateIndicator(calc);
              }
            }
          });
          template.chartData = chartData;
        }
      }
    });
  }

  // endregion

  // region Box management and actions
  printDate(format) {
    return moment().format(format);
  }

  setSettingMode() {
    this.currentIndicBoxMode = 'SETTINGS';
  }

  setThresholdMode() {
    this.currentIndicBoxMode = 'THRESHOLDS';
  }

  addIndicatorBox() {
    let sizeX = 2;
    let sizeY = 2;
    if (this.wholeWallboard.spacing === 40) {
      sizeX = 6;
      sizeY = 6;
    } else if (this.wholeWallboard.spacing === 75) {
      sizeX = 12;
      sizeY = 12;
    }
    this.currentWallboard.push({
      id: randomUUID(),
      type: 'INDICATOR',
      color: 'rgba(255,255,255,1)',
      background: 'rgba(0,0,0,0.75)',
      title: '',
      titleSize: 'MEDIUM',
      display: 'GRID',
      sizeX: sizeX,
      sizeY: sizeY,
      array: [],
    });
  }

  addTextBox() {
    let sizeX = 12;
    let sizeY = 1;
    if (this.wholeWallboard.spacing === 40) {
      sizeX = 20;
      sizeY = 3;
    } else if (this.wholeWallboard.spacing === 75) {
      sizeX = 30;
      sizeY = 6;
    }
    this.currentWallboard.push({
      id: randomUUID(),
      type: 'TEXT',
      background: 'rgba(255,255,255,1)',
      name: this.$i18next.t('wallboard:textBox'),
      text: '',
      sizeX: sizeX,
      sizeY: sizeY,
    });
  }

  addDateTimeBox() {
    let sizeX = 2;
    let sizeY = 1;
    if (this.wholeWallboard.spacing === 40) {
      sizeX = 6;
      sizeY = 3;
    } else if (this.wholeWallboard.spacing === 75) {
      sizeX = 12;
      sizeY = 6;
    }
    this.currentWallboard.push({
      id: randomUUID(),
      type: 'DATETIME',
      color: 'rgba(0,0,0,1)',
      background: 'rgba(255,255,255,1)',
      format: 'MMMM Do YYYY HH:mm',
      sizeX: sizeX,
      sizeY: sizeY,
    });
  }

  addImageBox() {
    let sizeX = 2;
    let sizeY = 2;
    if (this.wholeWallboard.spacing === 40) {
      sizeX = 6;
      sizeY = 6;
    } else if (this.wholeWallboard.spacing === 75) {
      sizeX = 12;
      sizeY = 12;
    }
    this.currentWallboard.push({
      id: randomUUID(),
      type: 'IMAGE',
      color: 'rgba(255,255,255,1)',
      background: 'rgba(0,0,0,0.75)',
      title: '',
      name: this.$i18next.t('wallboard:imageBox'),
      images: [],
      refreshMinutes: 0,
      refreshSeconds: 5,
      sizeX: sizeX,
      sizeY: sizeY,
    });
  }

  addMetaBox() {
    let hasMeta = false;
    this.currentWallboard.forEach(template => {
      if (template.type === 'META') {
        hasMeta = true;
      }
    });
    if (!hasMeta) {
      this.currentWallboard.push({
        id: randomUUID(),
        type: 'META',
        backgroundColor: 'rgba(0,0,0,0)',
        backgroundImage: '',
        backgroundContain: false,
      });
    }
  }

  getMetaBox() {
    let t = {
      id: randomUUID(),
      type: 'META',
      backgroundColor: 'rgba(0,0,0,0)',
      backgroundImage: '',
      backgroundContain: false,
    };
    this.currentWallboard.forEach(template => {
      if (template.type === 'META') {
        t = template;
      }
    });
    return t;
  }

  deleteBox(item) {
    if (item.type === 'IMAGE' && item.images != null) {
      item.images.forEach(image => this.removeImageToList(image.name));
    }
    for (let i = 0; i < this.currentWallboard.length; i++) {
      if (item.id === this.currentWallboard[i].id) {
        this.currentWallboard.splice(i, 1);
        break;
      }
    }
  }

  addIndicBox() {
    let newIndicBox = {
      id: randomUUID(),
      title: '',
      color: 'rgba(255,255,255,1)',
      background: 'rgba(255,255,255,0.35)',
      type: 'NORMAL',
      value: '-',
      hasThresholds: false,
      minThreshold: 0,
      maxThreshold: 0,
      minThresholdColor: 'rgba(246,139,31,1)',
      maxThresholdColor: 'rgba(158,11,15,1)',
      sizeX: 2,
      sizeY: 3,
      prefix: '',
      suffix: '',
    };
    if (this.currentBox.array === undefined) {
      this.currentBox.array = [];
    }
    this.currentBox.array.push(newIndicBox);
    this.editIndicBox(newIndicBox);
  }

  editIndicBox(item) {
    if (!this.wallboardMode) {
      this.setSettingMode();
      this.currentIndicBoxEdited = item;
      this.onChangeCurrentIndicBoxEditedFamily(true);
    }
  }

  deleteIndicBox(item) {
    if (item.id === this.currentIndicBoxEdited.id) {
      this.currentIndicBoxEdited = {};
    }
    for (let i = 0; i < this.currentBox.array.length; i++) {
      if (item.id === this.currentBox.array[i].id) {
        this.currentBox.array.splice(i, 1);
        break;
      }
    }
  }

  eraseCurrentIndicBox() {
    for (let i = 0; i < this.currentBox.array.length; i++) {
      if (this.currentIndicBoxEdited.id === this.currentBox.array[i].id) {
        this.currentBox.array[i].title = '';
        this.currentBox.array[i].color = 'rgba(255,255,255,1)';
        this.currentBox.array[i].background = 'rgba(255,255,255,0.35)';
        this.currentBox.array[i].type = 'NORMAL';
        this.currentBox.array[i].value = '-';
        this.currentBox.array[i].hasThresholds = false;
        this.currentBox.array[i].minThreshold = 0;
        this.currentBox.array[i].maxThreshold = 0;
        this.currentBox.array[i].minThresholdColor = 'rgba(246,139,31,1)';
        this.currentBox.array[i].maxThresholdColor = 'rgba(158,11,15,1)';
        this.currentBox.array[i].family = '';
        this.currentBox.array[i].target = '';
        this.currentBox.array[i].targetType = '';
        this.currentBox.array[i].indicator = '';
        this.currentBox.array[i].url = '';
        this.currentBox.array[i].refreshMinutes = 0;
        this.currentBox.array[i].refreshSeconds = 5;
        this.currentBox.array[i].prefix = '';
        this.currentBox.array[i].suffix = '';
        break;
      }
    }
  }

  openEditBox(item) {
    if (!this.wallboardMode && (item.type !== 'IMAGE' || this.imagesLoaded)) {
      this.hasOneboxEdited = true;
      this.originalEditedItem = copy(item);
      this.currentBox = item;
      if (item.type === 'TEXT') {
        // Use timeout in order to wait a digest cycle then init tinymce
        this.$timeout(() => {
          this.tinymce.init({
            selector: 'textarea#richtext',
            menubar: false,
            height: 175,
            fontsize_formats: '0.5em 0.75em 1em 1.25em 1.5em 1.75e 2em 2.25em 2.5em 2.75e 3em 4em',
            content_style: '.mce-content-body {font-size:1em;}',
            plugins: ['paste textcolor colorpicker'],
            toolbar1: 'undo redo | forecolor backcolor | bold italic fontsizeselect | preview',
          });
        });
      } else if (item.type === 'IMAGE') {
        this.originalImagesToAdd = copy(this.imagesToAdd);
        this.originalImagesToRemove = copy(this.imagesToRemove);
      }
    }
  }

  openMoveBox(item) {
    this.hasOneboxMoved = true;
    this.currentBox = item;
    this.currentBoxRow = this.currentBox.row;
    this.currentBoxCol = this.currentBox.col;
    this.currentBoxX = this.currentBox.sizeX;
    this.currentBoxY = this.currentBox.sizeY;
  }

  closeMoveBox() {
    this.hasOneboxMoved = false;
    this.currentBox = {};
  }

  cancelMoveBox() {
    this.currentBox.row = this.currentBoxRow;
    this.currentBox.col = this.currentBoxCol;
    this.currentBox.sizeX = this.currentBoxX;
    this.currentBox.sizeY = this.currentBoxY;
    this.closeMoveBox();
  }

  closeBox() {
    if (this.currentBox.type === 'TEXT') {
      this.currentBox.text = this.tinyMCE.get('richtext').getContent({ format: 'raw' });
      this.tinymce.remove();
    } else if (this.currentBox.type === 'IMAGE' && this.currentBox.images.length > 1) {
      this.currentWallboard.forEach(box => {
        if (box.id === this.currentBox.id) {
          if (box.slideshow != null) {
            clearInterval(box.slideshow);
          }
          box.slideshowIndex = 0;
          let refresh = box.refreshMinutes * 60000 + box.refreshSeconds * 1000;
          box.slideshow = setInterval(() => (box.slideshowIndex = (box.slideshowIndex + 1) % box.images.length), refresh);
        }
      });
      this.selectedImageIndex = null;
      this.deleteTempImage();
    } else if (this.currentBox.type === 'INDICATOR' && this.currentBox.display === 'SEQUENCE' && this.currentBox.array.length > 1) {
      this.currentWallboard.forEach(box => {
        if (box.id === this.currentBox.id) {
          if (box.sequence != null) {
            clearInterval(box.sequence);
          }
          box.sequenceIndex = 0;
          let interval = box.refreshMinutes * 60000 + box.refreshSeconds * 1000;
          box.sequence = setInterval(() => (box.sequenceIndex = (box.sequenceIndex + 1) % box.array.length), interval);
        }
      });
    }
    this.hasOneboxEdited = false;
    this.currentIndicBoxEdited = {};
    this.currentBox = {};
  }

  cancelEditBox() {
    for (let prop in this.originalEditedItem) {
      if (this.originalEditedItem.hasOwnProperty(prop)) {
        this.currentBox[prop] = this.originalEditedItem[prop];
      }
    }
    this.hasOneboxEdited = false;
    this.hasOneboxMoved = false;
    this.currentIndicBoxEdited = {};
    if (this.currentBox.type === 'TEXT') {
      this.tinymce.remove();
    } else if (this.currentBox.type === 'IMAGE') {
      this.selectedImageIndex = null;
      this.deleteTempImage();
      this.imagesToAdd = this.originalImagesToAdd;
      this.imagesToRemove = this.originalImagesToRemove;
    }
    this.currentBox = {};
  }

  canCloseBox() {
    let result = true;
    if (this.currentBox.type === 'INDICATOR') {
      if (this.currentBox.display === 'SEQUENCE' && (this.currentBox.array == null || this.currentBox.array.length > 5)) {
        result = false;
      }
      if (result) {
        forEach(this.currentBox.array, indicator => {
          if (indicator.type === 'NORMAL') {
            if (!indicator.indicator || !indicator.target || indicator.indicator === '' || indicator.target === '') {
              result = false;
            }
          } else if (indicator.type === 'CUSTOM') {
            if (indicator.indicator === '') {
              result = false;
            }
          } else if (indicator.type === 'EXTERNAL') {
            if (indicator.url === '') {
              result = false;
            }
          }
        });
      }
    }
    return result;
  }

  // endregion

  // region Wallboard update
  private canUpdateWallboard() {
    let wallboard = copy(this.wholeWallboard);
    wallboard.template = copy(this.currentWallboard);
    wallboard.template.forEach(box => {
      if (box.type === 'IMAGE') {
        delete box.slideshowIndex;
        delete box.slideshow;
      } else if (box.type === 'INDICATOR') {
        delete box.sequenceIndex;
        delete box.sequence;
      }
    });
    wallboard.template = toJson(wallboard.template);

    this.originalWallboard.template = fromJson(this.originalWallboard.template);
    this.originalWallboard.template.forEach(box => {
      if (box.type === 'IMAGE') {
        delete box.slideshowIndex;
        delete box.slideshow;
      } else if (box.type === 'INDICATOR') {
        delete box.sequenceIndex;
        delete box.sequence;
      }
    });
    this.originalWallboard.template = toJson(this.originalWallboard.template);

    return !(toJson(this.originalWallboard) === toJson(wallboard));
  }

  updateWallboard() {
    if (this.canUpdateWallboard()) {
      this.saveInProgress = true;
      // Add text zone id and image zone id list to wallboard
      this.wholeWallboard.textZoneIds = [];
      this.wholeWallboard.imageZoneIds = [];
      this.currentWallboard.forEach(template => {
        if (template.type === 'TEXT') {
          if (template.name == null) {
            template.name = this.$i18next.t('wallboard:textBox');
          }
          this.wholeWallboard.textZoneIds.forEach(textZoneId => {
            if (textZoneId === template.name) {
              let regex = /\((.*?)\)/g;
              if (regex.test(template.name)) {
                let matches = template.name.match(regex);
                let counter = matches[matches.length - 1];
                template.name = template.name.replace(counter, '');
                counter = counter.replace('(', '');
                counter = counter.replace(')', '');
                template.name = template.name + '(' + (parseInt(counter, 10) + 1) + ')';
              } else {
                template.name = template.name + ' (1)';
              }
            }
          });
          this.wholeWallboard.textZoneIds.push(template.name);
        } else if (template.type === 'IMAGE') {
          if (template.name == null) {
            template.name = this.$i18next.t('wallboard:imageBox');
          }
          this.wholeWallboard.imageZoneIds.forEach(imageZoneId => {
            if (imageZoneId === template.name) {
              let regex = /\((.*?)\)/g;
              if (regex.test(template.name)) {
                let matches = template.name.match(regex);
                let counter = matches[matches.length - 1];
                template.name = template.name.replace(counter, '');
                counter = counter.replace('(', '');
                counter = counter.replace(')', '');
                template.name = template.name + '(' + (parseInt(counter, 10) + 1) + ')';
              } else {
                template.name = template.name + ' (1)';
              }
            }
          });
          this.wholeWallboard.imageZoneIds.push(template.name);
        }
      });

      this.wholeWallboard.template = toJson(this.currentWallboard);
      delete this.wholeWallboard.id;
      delete this.wholeWallboard.uuidName;
      delete this.wholeWallboard.domain;

      // Images part (use a copy of the wallboard because we remove base64 images before saving it)
      let wallboardToSend = copy(this.wholeWallboard);
      wallboardToSend.template = fromJson(wallboardToSend.template);
      if (this.imagesToRemove.length > 0) {
        this.wallboardService.deleteImages(this.imagesToRemove, this.wholeWallboard.uuid).then(
          () => {
            this.imagesToRemove = [];
            this.toastDeprecatedService.add(ToastType.NOTIFICATION, 'wallboard:toast.removeImageSuccess', ToastClass.WALLBOARD, 2500);
          },
          () => this.toastDeprecatedService.alert('wallboard:toast.removeImageError')
        );
      }
      let fd = new FormData();
      wallboardToSend.template.forEach(template => {
        if (template.type === 'META') {
          if (this.imagesToAdd.indexOf(template.backgroundImage.name) > -1) {
            let file = WallboardViewCtrl.dataURLtoFile(template.backgroundImage.image);
            fd.append('image', file, template.backgroundImage.name);
          }
          delete template.backgroundImage.image;
        } else if (template.type === 'IMAGE') {
          template.images.forEach(image => {
            if (this.imagesToAdd.indexOf(image.name) > -1) {
              let file = WallboardViewCtrl.dataURLtoFile(image.image);
              fd.append('image', file, image.name);
            }
            delete image.image;
          });
        }
      });
      if (this.imagesToAdd.length > 0) {
        this.wallboardService.uploadImages(fd, this.wholeWallboard.uuid).then(
          () => {
            this.imagesToAdd = [];
            this.toastDeprecatedService.add(ToastType.NOTIFICATION, 'wallboard:toast.addImageSuccess', ToastClass.WALLBOARD, 2500);
          },
          () => this.toastDeprecatedService.alert('wallboard:toast.addImageError')
        );
      }

      // Remove image slideshow and indicator sequence
      wallboardToSend.template.forEach(template => {
        if (template.type === 'IMAGE') {
          delete template.slideshowIndex;
          delete template.slideshow;
        } else if (template.type === 'INDICATOR') {
          delete template.sequenceIndex;
          delete template.sequence;
        }
      });

      wallboardToSend.template = toJson(wallboardToSend.template);
      this.wallboardService.updateWallboard(wallboardToSend, this.wholeWallboard.uuid).then(
        () => {
          this.originalWallboard = copy(this.wholeWallboard);
          this.saveInProgress = false;
          this.toastDeprecatedService.add(ToastType.NOTIFICATION, 'wallboard:toast.saveSuccess', ToastClass.WALLBOARD, 2500);
        },
        () => {
          this.saveInProgress = false;
          this.toastDeprecatedService.alert('wallboard:toast.saveError');
        }
      );
    } else {
      this.toastDeprecatedService.add(ToastType.NOTIFICATION, 'wallboard:toast.saveSuccess', ToastClass.WALLBOARD, 2500);
    }
  }

  // endregion

  // region Images
  selectBoxImage(index) {
    this.selectedImageIndex = index;
    this.deleteTempImage();
  }

  deleteBoxImage(index) {
    this.removeImageToList(this.currentBox.images[index].name);
    this.currentBox.images.splice(index, 1);
    this.selectedImageIndex = null;
    this.deleteTempImage();
  }

  deleteTempImage() {
    if (this.tempEditionImage != null) {
      this.tempEditionImage.image = null;
      this.tempEditionImage.name = null;
    }
  }

  editBoxImage() {
    this.removeImageToList(this.currentBox.images[this.selectedImageIndex].name);
    this.currentBox.images[this.selectedImageIndex].name = this.tempEditionImage.name;
    this.currentBox.images[this.selectedImageIndex].image = this.tempEditionImage.image;
    this.imagesToAdd.push(this.tempEditionImage.name);
    this.deleteTempImage();
  }

  private removeImageToList(image) {
    let index = this.imagesToAdd.indexOf(image);
    if (index > -1) {
      this.imagesToAdd.splice(index, 1);
    } else {
      this.imagesToRemove.push(image);
    }
  }

  private initSlideshowMode() {
    this.currentWallboard.forEach(template => {
      if (template.type === 'IMAGE' && template.images.length > 1) {
        if (template.slideshowIndex == null && template.slideshow == null) {
          template.slideshowIndex = 0;
          let refresh = template.refreshMinutes * 60000 + template.refreshSeconds * 1000;
          template.slideshow = setInterval(
            () => (template.slideshowIndex = (template.slideshowIndex + 1) % template.images.length),
            refresh
          );
        }
      }
    });
  }

  private static dataURLtoFile(dataUrl) {
    let arr = dataUrl.split(',');
    let mime = arr[0].match(/:(.*?);/)[1];
    let bstr = atob(arr[1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    // Use Blob instead of File because of IE
    return new Blob([u8arr], { type: mime });
  }

  private initWallboardImages(wallboardId) {
    let imagesToGet = 0;
    // Calculate the number of images to get
    this.currentWallboard.forEach(template => {
      if (template.type === 'IMAGE' && template.images.length > 0) {
        imagesToGet += template.images.length;
      } else if (template.type === 'META' && template.backgroundImage.name != null && template.backgroundImage.name !== '') {
        imagesToGet++;
      }
    });
    if (imagesToGet > 0) {
      this.imagesLoaded = false;
    }
    // Get all images and save them in the original wallboard
    this.currentWallboard.forEach(template => {
      if (template.type === 'IMAGE' && template.images.length > 0) {
        template.images.forEach(image => {
          this.wallboardService.getImage(wallboardId, image.name).then(
            response => {
              image.image = response.data.data;
              imagesToGet--;
              if (imagesToGet === 0) {
                this.wholeWallboard.template = toJson(this.currentWallboard);
                this.originalWallboard = copy(this.wholeWallboard);
                this.imagesLoaded = true;
              }
            },
            () => {
              imagesToGet--;
              if (imagesToGet === 0) {
                this.imagesLoaded = true;
              }
            }
          );
        });
      } else if (template.type === 'META' && template.backgroundImage.name != null && template.backgroundImage.name !== '') {
        this.wallboardService.getImage(wallboardId, template.backgroundImage.name).then(
          response => {
            template.backgroundImage.image = response.data.data;
            imagesToGet--;
            if (imagesToGet === 0) {
              this.wholeWallboard.template = toJson(this.currentWallboard);
              this.originalWallboard = copy(this.wholeWallboard);
              this.imagesLoaded = true;
            }
          },
          () => imagesToGet--
        );
      }
    });
  }

  // endregion

  // region Exit without saving warning
  goToWallboardList() {
    if (!this.wallboardMode) {
      if (this.canUpdateWallboard()) {
        this.exitWallboardState = true;
      } else {
        this.confirmExitWallboard();
      }
    }
  }

  confirmExitWallboard() {
    window.onbeforeunload = null;
    this.router.navigate([Path.wallboardConf]);
  }

  cancelExitWallboard() {
    this.exitWallboardState = false;
  }

  // endregion

  // region Auto scroll for indicator box
  private scrollElement(elem, duration) {
    let child = elem.children[0];
    if (duration <= 0) {
      setTimeout(() => {
        child.style.top = '0px';
        setTimeout(() => {
          let scrollHeight = elem.clientHeight - child.clientHeight;
          this.scrollElement(elem, -1 * scrollHeight * this.scrollSpeed);
        }, 2000);
      }, 2000);
    } else {
      setTimeout(() => {
        let top = 0;
        if (child.style.top !== '') {
          top = parseInt(child.style.top.replace('px', ''), 10);
        }
        child.style.top = top - 1 + 'px';
        this.scrollElement(elem, duration - this.scrollSpeed);
      }, this.scrollSpeed);
    }
  }

  private initAutoScroll() {
    let indicatorScrolls = [].slice.call(document.getElementsByClassName('indicator-grid-scroll'));
    indicatorScrolls.forEach(indicatorScroll => {
      let child = indicatorScroll.children[0];
      if (child !== undefined) {
        let scrollHeight = indicatorScroll.clientHeight - child.clientHeight;
        if (scrollHeight < 0) {
          this.scrollElement(indicatorScroll, -1 * scrollHeight * this.scrollSpeed);
        }
      }
    });
  }

  // endregion

  // region Sequence mode
  private initSequenceMode() {
    this.currentWallboard.forEach(template => {
      if (template.type === 'INDICATOR' && template.display === 'SEQUENCE' && template.array.length > 1) {
        template.sequenceIndex = 0;
        let interval = template.refreshMinutes * 60000 + template.refreshSeconds * 1000;
        template.sequence = setInterval(() => (template.sequenceIndex = (template.sequenceIndex + 1) % template.array.length), interval);
      }
    });
  }

  // endregion

  // region Sup messages
  private onNewMessage(data) {
    forEach(this.currentWallboard, box => {
      if (box.name === data.textZone) {
        box.text = data.message;
      }
    });
  }

  private onNewContent(data) {
    let MAX_TIMEOUT = 0x7fffffff;
    data.contents.forEach(content => {
      if (content.command === 'ADD') {
        if (content.type === 'TEXT') {
          this.currentWallboard.forEach(box => {
            if (box.type === 'TEXT' && box.name === content.target) {
              if (box.content == null) {
                box.content = [{ uuid: content.uuid, value: content.content }];
                box.contentIndex = 0;
              } else {
                box.content.push({ uuid: content.uuid, value: content.content });
                // Init the slideshow the first time there is more then one content
                if (box.content.length > 1 && box.contentSlideshow == null) {
                  box.contentSlideshow = setInterval(() => {
                    if (box.content.length !== 0) {
                      box.contentIndex = (box.contentIndex + 1) % box.content.length;
                    } else {
                      box.contentIndex = 0;
                    }
                  }, this.configuration.wallboardContentMessageInterval);
                }
              }
              // Calculate the duration of the content and set when to remove it
              let date = new Date();
              let timeout = content.endDate - date.getTime();
              if (timeout > MAX_TIMEOUT) {
                timeout = MAX_TIMEOUT;
              }
              setTimeout(() => {
                let index = box.content.map(c => c.uuid).indexOf(content.uuid);
                if (index !== -1) {
                  box.content.splice(index, 1);
                  if (box.content.length === 0) {
                    clearInterval(box.contentSlideshow);
                    delete box.contentSlideshow;
                  }
                }
              }, timeout);
            }
          });
        } else if (content.type === 'IMAGE') {
          this.currentWallboard.forEach(box => {
            if (box.type === 'IMAGE' && box.name === content.target) {
              this.wallboardService.getImage(this.wallboardUuid, content.content).then(response => {
                if (box.content == null) {
                  box.content = [
                    {
                      uuid: content.uuid,
                      name: content.content,
                      image: response.data.data,
                    },
                  ];
                  box.contentIndex = 0;
                } else {
                  box.content.push({
                    uuid: content.uuid,
                    name: content.content,
                    image: response.data.data,
                  });
                  // Init the slideshow the first time there is more then one content
                  if (box.content.length > 1 && box.contentSlideshow == null) {
                    box.contentSlideshow = setInterval(() => {
                      if (box.content.length !== 0) {
                        box.contentIndex = (box.contentIndex + 1) % box.content.length;
                      } else {
                        box.contentIndex = 0;
                      }
                    }, this.configuration.wallboardContentMessageInterval);
                  }
                }
                // Calculate the duration of the content and set when to remove it
                let date = new Date();
                let timeout = content.endDate - date.getTime();
                if (timeout > MAX_TIMEOUT) {
                  timeout = MAX_TIMEOUT;
                }
                setTimeout(() => {
                  let index = box.content.map(c => c.uuid).indexOf(content.uuid);
                  if (index !== -1) {
                    box.content.splice(index, 1);
                    if (box.content.length === 0) {
                      clearInterval(box.contentSlideshow);
                      delete box.contentSlideshow;
                    }
                  }
                }, timeout);
              });
            }
          });
        }
      } else if (content.command === 'REMOVE') {
        this.currentWallboard.forEach(box => {
          if (box.type !== 'META' && box.content != null) {
            let index = box.content.map(c => c.uuid).indexOf(content.uuid);
            if (index !== -1) {
              box.content.splice(index, 1);
              if (box.content.length === 0) {
                clearInterval(box.contentSlideshow);
                delete box.contentSlideshow;
              }
            }
          }
        });
      }
    });
  }

  // endregion
}

export class WallboardView implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    login: '<',
    close$: '<',
    toggle$: '<',
    demoMode: '=',
    wallboardMode: '=',
    wholeWallboard: '=',
    headerHover: '=',
  };
  controller = [
    '$log',
    '$i18next',
    '$timeout',
    'profileFacade',
    'wallboardService',
    'toastDeprecatedService',
    'messaging',
    'configuration',
    'wallboardRouter',
    WallboardViewCtrl,
  ];
}

export default MODULE_NAME;
